'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosColorWandOutline = function IoIosColorWandOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 11.7l20 20-2.7 2.7-20-20z m1.6 5.2l15.7 15.7 0.9-0.9-15.7-15.8z m-2.2-8.8v-3.1h1.2v3.1h-1.2z m0 16v-3.2h1.2v3.2h-1.2z m7.5-9.1v-1.2h3.1v1.2h-3.1z m-16.9 0v-1.2h3.1v1.2h-3.1z m3.7-7.7l2.2 2.3-0.9 0.9-2.2-2.2z m2.2 12.2l-2.2 2.2-0.9-0.8 2.2-2.2z m11.3-11.2l-2.2 2.2-0.9-0.9 2.2-2.3z' })
        )
    );
};

exports.default = IoIosColorWandOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-color-wand-outline.js
// module id = 2162
// module chunks = 0